import LedgersRepository from "./LedgersRepository";
import ItemsRepository from "./ItemsRepository";
import BillsRepository from "./BillsRepository";
import QuotationsRepository from "./QuotationsRepository";
import SalesRepository from "./SalesRepository";
import PurchaseRepository from "./PurchaseRepository";
import DateBookRepository from "./DateBookRepository";
import RackRepository from "./RackRepository";
import UsersRepository from "./UserRepository";
import FileRepository from "./FileRepository";
import DefaultRepository from "./DefaultRepository";
import SalaryRepository from "./SalaryRepository";
import ShopsRepository from "./ShopsRepository";
import NotificationRepository from "./NotificationRepository";
import StockRepository from "./StockRepository";
import EmailRepository from "./EmailRepository";
import FastCashRepository from "./FastCashRepository";
import CompanyRepository from "./CompanyRepository";
import InvoicesRepository from "./InvoicesRepository";
import Repo from "./Repo";

const repositories = {
  ledger_repository: LedgersRepository,
  items_repository: ItemsRepository,
  bills_repository: BillsRepository,
  quotations_repository: QuotationsRepository,
  file_repository: FileRepository,
  sales_repository: SalesRepository,
  purchase_repository: PurchaseRepository,
  datebook_repository: DateBookRepository,
  rack_repository: RackRepository,
  users_repository: UsersRepository,
  default_repository: DefaultRepository,
  salary_repository: SalaryRepository,
  shops_repository: ShopsRepository,
  notifications_repository: NotificationRepository,
  stock_repository: StockRepository,
  email_resource: EmailRepository,
  fastcash_resource: FastCashRepository,
  company_resource: CompanyRepository,
  invoice_resource: InvoicesRepository,
  repo_resource: Repo,
};

// eslint-disable-next-line import/prefer-default-export
export const RepositoryFactory = {
  get: (name) => repositories[name],
};
